module.exports = __webpack_public_path__ + "static/img/channel.3.1902aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channel.3.png
// module id = 222
// module chunks = 138 379 380